import { PUBLIC_BASE_URL, GAME_ID, HEADERS } from '@config/game.js'
import { normalizeSort } from '@composables/useSort.js'
import { requestAll } from '@helpers/requestAll.js'
import { queryString } from '@helpers/utils.js'
import { createClient } from '@services'

const { get } = createClient()

/* API request to get mods for game */
export async function getModsForGameRequest(query) {
  const { data } = await get(
    `${PUBLIC_BASE_URL}/games/${GAME_ID}/mods${queryString(query)}`
  )

  const sort = query?._sort ? normalizeSort(query._sort) : ''

  return { ...data, result_sort: sort }
}

/* API request to get mod */
export async function getModRequest(modNameId) {
  const { data } = await get(
    `${PUBLIC_BASE_URL}/games/${GAME_ID}/mods/@${modNameId}`,
    {
      headers: {
        'X-Modio-Platform': HEADERS.platform || 'windows',
      },
    }
  )
  return data
}

export async function getDependenciesRequest(modNameId) {
  const { data } = await get(
    `${PUBLIC_BASE_URL}/games/${GAME_ID}/mods/@${modNameId}/dependencies`
  )
  return data
}

/* API request to get team members for a mod */
export async function getModTeamMembersRequest(modNameId) {
  const { data } = await get(
    `${PUBLIC_BASE_URL}/games/${GAME_ID}/mods/@${modNameId}/team`
  )
  return data
}

/* API request to get files for a mod */
export function getAllFilesRequest(modNameId, query) {
  return requestAll(
    `${PUBLIC_BASE_URL}/games/${GAME_ID}/mods/@${modNameId}/files`,
    query
  )
}
